module.exports = __webpack_public_path__ + "img/1177.c657f070.gif";